export default {
  translation: {
    //////////  TOP MENU //////////
    topMenu: {
      signin: 'Sign in',
      about: 'About',
      support: 'Support',
      newsResources: 'News & Resources',
    },

    ////////// BOTTOM MENU //////////
    bottomMenu: {
      plans: 'Plans',
      product: 'Product',
      contact: 'Contact',
      freeTrial: 'Free trial',
      allPricesInAUD: 'All prices in Australian dollars',
      allPricesInUS: 'All prices in US dollars',
      allPricesInEUR: 'All prices in Euros',
      allPricesInGBP: 'All prices in GBP',
      termsText: 'By downloading Eyetelligence Software you agree to our ',
      privatePolicy: 'Privacy Policy',
      and: 'and',
      termsCondition: 'Terms & Conditions'
    },

    ////////// SIGN IN //////////
    signin: {
      login: 'Log in',
      title: 'Sign in to access your Eyetelligence Assure account.',
      forgotPassword: 'Forgot password?',
      freeTrial: 'No account? Start your free trial.',
      inputLabel1: 'Email',
      inputLabel2: 'Password',
    },

    ////////// SIGN UP //////////
    signup: {
      clinic: {
        firstStep: {
          title: 'Welcome. Tell us a bit about your clinic',
          desc: 'This will help us to ensure you get the right solution for your team.',
          inputLabel1: 'Clinic/practice name',
          inputLabel2: 'Your Position',
          inputLabel3: 'Number of retinal/OCT cameras',
        },
        thirdStep: {
          title: 'Your order',
          planType: 'Plan type',
          freeTrial: 'Free 30 day Trial',
          buttonText: 'Start your free trial',
        },
        fourStep: {
          title: 'Almost there!',
          desc: 'Please check your inbox. We’ve sent you an email with a verification link.',
        },
      },
      company: {
        firstStep: {
          title: 'Tell us about your company',
          desc: 'This will help us to ensure you get the right solution for your team.',
          inputLabel1: 'Company/practice name',
          inputLabel2: 'Your Position',
          inputLabel3: 'Country',
          inputLabel4: 'How many clinics?',
          inputLabel5: 'Do you have a centralised IT system?',
          inputLabel6: 'Yes',
          inputLabel7: 'No',
          buttonText: 'Continue',
        },
        thirdStep: {
          title: 'Confirm your details',
          desc: 'Please review the details below and confirm that everything is correct.',
          looksGood: 'Looks good',
        },
        fourStep: {
          title: 'Thanks!',
          desc:
            'Our team will be in touch within 48 hours to set you up for your free 30-day trial.',
        },
      },
      secondStep: {
        title: 'Tell us a bit about you',
        desc: 'We’ll use this info to set up your free trial and customise your account.',
        accountLink: 'Already have an acсount?',
        inputLabel1: 'Your Full Name',
        inputLabel2: 'Phone number (optional)',
        inputLabel3: 'Email',
        inputLabel4: 'Create password (min 6 max 64)',
        inputLabel5: 'Confirm password',
      },
      infoBlock: {
        yourName: 'Your Name',
        yourPosition: 'Your Position',
        email: 'Email',
        phone: 'Phone',
        companyName: 'Company Name',
        clinicName: 'Clinic Name',
        numberOf: 'Number of',
        clinics: 'Clinics',
        computers: 'Cameras',
      },
    },

    ////////// CONFIRM REGISTER //////////
    confirmSuccess: {
      title: 'Success!',
      desc:
        'Your email has been verified. Continue to the next page to complete the signup process and start downloading your free trial.',
    },

    ////////// RESET PASSWORD //////////
    resetPassword: {
      title: 'Change Password',
      mistmatch: 'Password mismatch',
      inputLabel1: 'Current Password',
      inputLabel2: 'New Password',
      inputLabel3: 'Repeat New Password',
      buttonText: 'Save changes',
    },

    ////////// FORGOT PASSWORD //////////
    forgotPassword: {
      title: 'Forgot password?',
      forgotPassword: 'Forgot password?',
      resetPassword: 'Reset Password',
      freeTrial: 'No account? Start your free trial.',
      inputLabel1: 'Email',
      inputLabel2: 'Password',
    },

    ////////// CREATE NEW PASSWORD //////////
    createNewPassword: {
      title: 'Create new password',
      inputLabel1: 'Create new password',
      inputLabel2: 'Сonfirm new password',
      buttonText: 'Confirm',
    },

    ////////// SIGN UP CLINICS //////////
    signupClinics: {
      title: 'Sign up for Eyetelligence',
      inputLabel1: 'Full Name',
      inputLabel2: 'Email',
      inputLabel3: 'Password',
      inputLabel4: 'Mobile Number (optional)',
      inputLabel5: 'Company Name',
      inputLabel6: 'Store Location',
      inputLabel7: 'Store Phone',
      buttonText: 'Done',
    },

    ////////// GENERAL //////////
    general: {
      backToDashboard: 'BACK TO DASHBOARD',
      backToLicence: 'BACK TO LICENCE',
      backToLogin: '< Back to login',
      step: 'Step',
      of: 'of',
      edit: 'EDIT',
      hi: 'Hi',
      loading: 'Loading',
      continue: 'Continue',
    },

    ////////// DASHBOARD //////////
    dashboard: {
      yourCurrentPlan: 'Your Current Plan',
      expired: 'Expired',
      startedfrom: 'Started from',
      nextBillableDate: 'next billable date',
      youHave: 'You have',
      licences: 'licences',
      manageLicences: 'Manage Licences',
      billingHistory: 'Billing History',
      receipt: 'RECEIPT',
      youHaveNoBillingHistory: 'You have no billing history...',
      accountInformation: 'Account Information',
      name: 'Name',
      email: 'Email',
      phone: 'Phone',
      clinicName: 'Clinic Name',
      yourPosition: 'Your Position',
      passwordDetails: 'Password Details',
      creditCardDetails: 'Credit Card Details',
      clickCounter: 'Click counter',
      change: 'CHANGE',
      contactUs: 'Contact Us',
      pleaseClick: 'Please click',
      here: 'here',
      help: 'if you would like help with your account or Eyetelligence products',
      activetedCamera: 'Camera has been successfully activated',
      deactivatedCamera: 'Camera has been successfully deactivated',
      cahgedNickname: 'Camera nickname changed successfully',
    },

    ////////// ENTERPRISE PLAN //////////
    enterprisePlan: {
      freeTrial: 'Your 30-day free trial of Eyetelligence Assure has ended.',
      desc:
        'Your trial has now expired, but not to worry. You can continue leveraging the powerful benefits of AI for your patients. One of our team will be in contact to discuss next steps, or you can get in touch via the email below.',
      contactUs: 'Contact us',
      email: 'Email',
      mail: 'Mail',
      street: 'Level 14, 333 Collins Street',
      city: 'Melbourne, Victoria Australia',
      chat: 'Let’s chat',
      description:
        'Get in touch with our team today. We’re here to help you and ready to answer your questions and enquiries.',
      loading: 'Loading',
    },

    ////////// LICENCE //////////
    licence: {
      isDelete: 'Are you sure to cancel current plan?',
      newNname: 'New name',
      maxCharacters: 'Max 32 characters',
      minCharacters: 'Min 1 character',
      yourLicenceSummary: 'Your licence summary',
      cancelPlan: 'Cancel plan',
      computerID: 'Computer ID',
      activationCode: 'Activation Code',
      validDate: 'Valid Date',
      activate: 'Activate',
      revoke: 'Revoke',
      number: 'Number',
      nickname: 'Nickname',
      status: 'Status',
      active: 'Active',
      inactive: 'Inactive',
      needLicence: 'Need a new licence',
      upgradePlan: 'Upgrade plan',
      cancelPlanPopup: 'Are you sure you want to cancel this plan?'
    },

    ////////// PLAN //////////
    plan: {
      cardDetails: 'Card details',
      pay: 'Pay',
      title: 'Order Summary',
      planType: 'Plan type',
      annual: 'Annual',
      annually: 'Annually (Pay annually and save 10%)',
      monthly: 'Monthly',
      payPerClick: 'Pay per click',
      freeTrial: 'Free 30 day Trial',
      eachYear:
        'Billed automatically each year. You can edit your plan or billing information through your account dashboard. You may cancel your subscription payment at any time. The remaining days of your subscription will be provided to you as a refund.',
      eachMonth:
        'Billed automatically each month. You can edit your plan or billing information through your account dashboard. You may cancel your subscription payment at any time. The remaining days of your subscription will be provided to you as a refund.',
      updateCurrentPlan: 'Update current plan',
      addCard: 'Add card',
      successfullyUpdated: 'Plan has been successfully updated',
      computerHaveInternet: 'Do the computers in your practice have access to the internet?',
      yes: 'yes',
      no: 'no',
    },

    ////////// UPGRADE PLAN //////////
    upgradePlan: {
      upTo: 'Up to',
      upToSmall: 'Up to',
      upToLowerCase: 'up to',
      cameras: 'cameras',
      specialOffer: 'Special Offer',
      month: 'month',
      monthUppCase: 'month',
      monthShort: 'mo',
      mainTitle: 'Choose the plan that’s right for you',
      mainSubTitle: 'Time to make this partnership official. Select your subscription plan below and continue enjoying all the benefits of Eyetelligence Assure. \n' +
          'Need help choosing a plan? Simply contact our team to find the plan that’s right for you.',
      freeTrial: 'Your 30-day free trial of Eyetelligence Assure has ended.',
      timeToMake:
        'Time to make this partnership official. Select your subscription plan below and continue enjoying all the benefits of Eyetelligence Assure.',
      needHelp:
        'Pricing is per camera, per month, cancel anytime. Free one month trial for all plans. No credit card required. Try it now.',
      chooseThePlan: 'Choose the plan that’s right for you',
      single: 'Single',
      cameraLicence: 'Camera Licence',
      annuallySave: 'Billed annually, save',
      multipleSave: 'Per camera, billed annually, save',
      orPay: 'Or pay',
      billedMonthly: 'billed monthly',
      billedMonthlyMultiple: 'billed monthly',
      multiple: 'Multiple',
      cameraLicences: 'Camera Licences',
      perCamera: 'Per camera, billed monthly, save',
      perCameraShort: 'per camera',
      perAnalysis: 'per analysis',
      enterprise: 'Enterprise',
      youHaveSix:
        'If you have six cameras or more, we would be happy to help tailor a plan and any requirements to suit you, to ensure you get the right solution for your team.',
      select: 'Select Plan',
      FAQ: 'FAQ',
      FAQ1Title: 'Do I need to commit to a full-year plan?',
      FAQ1Desc:
        'No, we offer both monthly and annual plans. Annual plans are billed upfront (monthly price is shown for comparison). By selecting an annual plan, you will receive 20% off your subscription.',
      FAQ2Title: 'Can I change my plan?',
      FAQ2Desc:
        'Yes, you can upgrade, downgrade, or cancel your plan at any time through your account dashboard.',
      FAQ3Title: 'What is the cancellation policy?',
      FAQ3Desc:
        'You can cancel your plan at any time through your account dashboard. Once cancelled you will not be charged at your next billing period. You will be able to access Eyetelligence Assure for the remainder of your billing period. No refunds will be issued for the remaining time.',
      chat: 'Let’s chat',
      getInTouch:
        'Get in touch with our team today. We’re here to answer your questions and enquiries.',
      getInTouchButton: 'Get in touch',
    },

    ////////// PROFILE //////////
    profile: {
      title: 'Account Information',
      clinicName: 'Clinic name',
      yourPosition: 'Your position',
      yourFullName: 'Your Full Name',
      phoneNumber: 'Phone Number',
      email: 'Email',
      saveChanges: 'Save changes',
    },
    creditCard: {
      title: 'Credit cards details',
      delete: 'Delete',
    },
    updateUserData: {
      updateUserInfo: 'Your info has been successfully updated',
      passwordUpdate: 'Password has been successfully updated',
      cardAdded: 'Your card has been successfully added',
      cardDelete: 'Your card has been successfully delete',
    },

    ////////// AUTH //////////
    auth: {
      linkSent: 'Link sent to email',
      passwordReset: 'Your password is reset successfully',
    },
  },
};
